import { createTheme } from '@mui/material/styles';
import { cubicTransition } from './transitions';

const theme = createTheme({
  direction: 'rtl',
  palette: {
    primary: {
      main: '#29862F',
    },
    secondary: {
      main: '#df8985',
    },
    primaryLight80: '#ccefce',
    secondaryRed: '#D76B66',
    secondaryOrange: '#EA973D',
    secondaryYellow: 'F6CF7D',
    paperGrey: '#fcfcfd',
    divider: 'rgba(0, 0, 0, 0.12)',
    dividerLight: '#EBEBEF',
  },
  typography: {
    fontFamily: ['Assistant', 'sans-serif'].join(','),
  },
  sizes: {
    general: {
      drawer: { open: 218, closed: 68 },
      detailsDrawer: { open: 780, closed: 0 },
      topBar: {
        height: 64,
      },
    },
  },
  transitions: {
    easing: {
      custom: cubicTransition,
    },
  },
});

type TransitionProps =
  | {
      duration?: number;
      easing?: string;
      property?: string;
      delay?: number;
    }
  | undefined;

const DEFAULT_TRANSITION_PROPS: TransitionProps = {
  duration: 0.3,
  easing: theme.transitions.easing.custom,
};
/**
 * Custom transition helper (defaults)
 * @param duration - transition duration in seconds (0.3)
 * @param easing - transition easing (cubicTransition = cubic-bezier(.03,.98,.52,.99))
 * @param property - transition property
 * @param delay - transition delay
 */
const transition = ({
  duration = DEFAULT_TRANSITION_PROPS.duration,
  easing = DEFAULT_TRANSITION_PROPS.easing,
  property,
  delay,
}: TransitionProps = DEFAULT_TRANSITION_PROPS) =>
  `${property ? `${property} ` : ''}${
    typeof duration === 'number' ? `${duration}s` : duration
  } ${`${easing} `}${delay ?? ''}`;

export default theme;
export { transition };
